import { signInReturnTo } from './signInReturnTo.ts';

/*
 * Where the last sign-in link asked for in this browser was meant to lead. A
 * refused link sends its reader back to the login screen, and a fresh link
 * from there should still lead to that page. The link only works in the
 * browser that asked for it, so this browser is the one to remember it.
 */

const STORAGE_KEY = 'wundo.signIn.requestedRedirect';

/* Long enough for yesterday's mail, short enough that nobody meets a stale page. */
const REMEMBERED_FOR_MS = 24 * 60 * 60 * 1000;

interface Remembered {
  redirect: string;
  at: number;
}

export function rememberRequestedRedirect(redirect: string | undefined): void {
  try {
    if (!redirect) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    const remembered: Remembered = { redirect, at: Date.now() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(remembered));
  } catch {
    /* A fresh link then lands on the default page. */
  }
}

export function requestedRedirect(): string | undefined {
  let remembered: Partial<Remembered> | null;
  try {
    remembered = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? 'null');
  } catch {
    return undefined;
  }
  if (
    typeof remembered?.at !== 'number' ||
    Date.now() - remembered.at > REMEMBERED_FOR_MS
  ) {
    return undefined;
  }

  return signInReturnTo(remembered.redirect);
}
